import { createI18n } from 'vue-i18n'

import enGB from './locales/en-GB.json'

/**
 * One locale for now. Every string still goes through the catalogue so adding
 * a second is a translation job rather than a hunt through templates.
 */
export const i18n = createI18n({
  legacy: false,
  locale: 'en-GB',
  fallbackLocale: 'en-GB',
  messages: { 'en-GB': enGB },
})
